import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { LoginService } from '../login/login.service';
import 'rxjs/Rx';
import 'rxjs/add/operator/map'
import { Observable } from 'rxjs';

@Injectable()
export class AuthLoginGuard implements CanActivate {
  
  constructor(private loginService: LoginService, private router: Router){

  }
  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | boolean {
    let url: string = state.url;
    // return this.checkUserLogin(route, url);
    if (this.loginService.loggedIn()) {
      return this.loginService
            .isEmployeeUserOnLine()
            .map((e) => {
                if (e) {
                  console.log(e);
                  const userRole = this.loginService.getRole();
                  if (userRole != 'Candidate') {
                    return true;
                  }
                }
            })
            .catch(() => {
                this.loginService.logout;
                this.router.navigate(['/login-candidate']);
                return Observable.of(false);
            });
    }
    else
      return false;
  }
  checkUserLogin(route: ActivatedRouteSnapshot, url: any): Observable<boolean> | boolean {
    if (this.loginService.loggedIn()) {
      const userRole = this.loginService.getRole();
      if (userRole != 'Candidate') {
        return true;
      }
    }

    this.router.navigate(['/login']);
    return false;

    
  }
}



// WEBPACK FOOTER //
// D:/inetpub/wwwroot/kaizen-ng/src/app/modules/employee/service/auth-guard-login/auth-login.guard.ts